"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLogOutput = instanceOfLogOutput;
exports.LogOutputFromJSON = LogOutputFromJSON;
exports.LogOutputFromJSONTyped = LogOutputFromJSONTyped;
exports.LogOutputToJSON = LogOutputToJSON;
var Log_1 = require("./Log");
var Metadata_1 = require("./Metadata");
/**
 * Check if a given object implements the LogOutput interface.
 */
function instanceOfLogOutput(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function LogOutputFromJSON(json) {
    return LogOutputFromJSONTyped(json, false);
}
function LogOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(Log_1.LogFromJSON)),
        'metadata': json['metadata'] == null ? undefined : (0, Metadata_1.MetadataFromJSON)(json['metadata']),
    };
}
function LogOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(Log_1.LogToJSON)),
        'metadata': (0, Metadata_1.MetadataToJSON)(value['metadata']),
    };
}
